module.exports = __webpack_public_path__ + "img/mm-rex.e5ecccbd.svg";